<template>
	<div class="text-with-select">
		<div class="select-area">
			<div class="title-label">{{ title }}</div>
			<div class="label-label">{{ label }}</div>
			<div class="select-item"><slot name="select"></slot></div>
		</div>
		<div class="text-area">
			<slot name="text"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
			},
			label: {
				type: String,
				default: '',
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
